import { PageRef } from 'providers/page-ref';

export type AdminRootPageParams = {};

export const IAdminRootPage: PageRef<AdminRootPageParams, void> = {
  pageName: 'AdminRootPage',
} as PageRef<AdminRootPageParams, void>;
